import { render } from "./ListeLangue.vue?vue&type=template&id=acbe0d24&ts=true"
import script from "./ListeLangue.vue?vue&type=script&lang=ts"
export * from "./ListeLangue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__